
export function sort(data: any[], fieldDefs: any): any[] {
	const sortField = fieldDefs.orderBy;
	if (!sortField) {
		return data;
	}
	return sortBy(data,
		record => !fieldDefs.orderByCaseSensitive
			? record[sortField].toLowerCase()
			: record[sortField],
		fieldDefs.ascending);
}

function compare<T>(a: T, b: T): number {
	return a > b ? 1 :
		a < b ? -1 : 0;
}

function sortBy<T, V>(items: T[], valueFn: (item: T) => V, ascending: boolean = true): T[] {
	return items.concat().sort((a, b) => {
		const valA = valueFn(a);
		const valB = valueFn(b);
		return ascending ? compare(valA, valB) : compare(valB, valA);
	});
}
